var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElSelect',{attrs:{"value":_vm.value,"placeholder":_vm.$t('ADVERTISEMENT.BID.MATCH_TYPE')},on:{"input":_vm.emitValue}},_vm._l((_vm.matchingTypes),function(matchType){return _c('ElOption',{key:matchType.property,attrs:{"label":matchType.label,"value":matchType.property}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }